import RiskInsurance from '__core/shared/model/riskInsurance/RiskInsurance';
import RiskInsuranceCompliance from '__core/shared/model/riskInsurance/RiskInsuranceCompliance';
import RiskInsuranceComplianceVerifications from '__core/shared/model/riskInsurance/RiskInsuranceComplianceVerifications';
import RiskInsuranceProduct from '__core/shared/model/riskInsurance/RiskInsuranceProduct';
import { RiskInsuranceProductType } from '__core/shared/model/riskInsurance/RiskInsuranceProduct.enum';
import RiskInsuranceRequirements from '__core/shared/model/riskInsurance/RiskInsuranceRequirements';
import RiskInsuranceRequirementsApplicant from '__core/shared/model/riskInsurance/RiskInsuranceRequirementsApplicant';
import RiskInsuranceRequirementsNatureOfServiceSought from '__core/shared/model/riskInsurance/RiskInsuranceRequirementsNatureOfServiceSought';
import RiskInsuranceRequiremetsAssistanceInIdentifyingInsuranceIssues from '__core/shared/model/riskInsurance/RiskInsuranceRequiremetsAssistanceInIdentifyingInsuranceIssues';
import riskInsuranceController from './riskInsurance.controller';
import stRiskInsuranceRequirements from './riskInsuranceRequirements.component';
import stRiskInsuranceRequirementsApplicants from './riskInsuranceRequirementsApplicants.component';
import stRiskInsuranceProducts from './riskInsuranceProducts.component';
import stRiskInsuranceProduct from './riskInsuranceProduct.component';
import stRiskInsuranceCompliance from './riskInsuranceCompliance.component';
import stRiskInsuranceComplianceVerificationIdentity from './riskInsuranceComplianceVerificationIdentity.component';

export default angular
  .module('st.RiskInsurance', [
    'st.Core',
    'angular-cache',
    'st.Core.GoogleMaps',
    'ui.utils.masks',
    'vsGoogleAutocomplete'
  ])
  .factory('RiskInsurance', () => RiskInsurance)
  .factory('RiskInsuranceCompliance', () => RiskInsuranceCompliance)
  .factory('RiskInsuranceComplianceVerifications', () => RiskInsuranceComplianceVerifications)
  .factory('RiskInsuranceProduct', () => RiskInsuranceProduct)
  .factory('RiskInsuranceProductType', () => RiskInsuranceProductType)
  .factory('RiskInsuranceRequirements', () => RiskInsuranceRequirements)
  .factory('RiskInsuranceRequirementsApplicant', () => RiskInsuranceRequirementsApplicant)
  .factory(
    'RiskInsuranceRequirementsNatureOfServiceSought',
    () => RiskInsuranceRequirementsNatureOfServiceSought
  )
  .factory(
    'RiskInsuranceRequiremetsAssistanceInIdentifyingInsuranceIssues',
    () => RiskInsuranceRequiremetsAssistanceInIdentifyingInsuranceIssues
  )
  .controller('riskInsuranceController', riskInsuranceController)
  .component('stRiskInsuranceRequirements', stRiskInsuranceRequirements)
  .component('stRiskInsuranceRequirementsApplicants', stRiskInsuranceRequirementsApplicants)
  .component('stRiskInsuranceProducts', stRiskInsuranceProducts)
  .component('stRiskInsuranceProduct', stRiskInsuranceProduct)
  .component('stRiskInsuranceCompliance', stRiskInsuranceCompliance)
  .component(
    'stRiskInsuranceComplianceVerificationIdentity',
    stRiskInsuranceComplianceVerificationIdentity
  )
  .service(
    'riskInsuranceService',
    (
      RiskInsurance,
      RiskInsuranceProduct,
      RiskInsuranceProductType,
      dataService,
      helperService
    ) => {
      const getAvailableRiskInsuranceProductTypes = () => RiskInsuranceProductType.available();

      const riskInsuranceProductAdd = (products, productType) => {
        const product = RiskInsuranceProduct.blank(productType);
        products.push(product);
        return products;
      };

      const riskInsuranceProductDelete = (products, index) =>
        helperService.removeItemFromArray(products, index);

      return {
        getAvailableRiskInsuranceProductTypes,
        riskInsuranceProductAdd,
        riskInsuranceProductDelete,
        createRiskInsurance: (doc) => dataService.createDocument(RiskInsurance, doc),
        readRiskInsurance: (doc) => dataService.readDocument(RiskInsurance, doc),
        updateRiskInsurance: (doc) => dataService.updateDocument(RiskInsurance, doc),
        deleteRiskInsurance: (doc) => dataService.deleteDocument(RiskInsurance, doc)
      };
    }
  )
  .constant('RISK_INSURANCE', {
    API: {}
  });
